export default __webpack_public_path__ + "static/adhdpro-1-8d70bdd48e6197757aec65457ddef00b.png";